import { post } from "@utils/httpUtil";
export function catalogDelete(data, config) {
  return post("/baseQuestionnaire/catalog/delete", data, config);
}
export function deleteCatalogAndRelation(data, config) {
  return post("/baseQuestionnaire/catalog/deleteCatalogAndRelation", data, config);
}
export function getById(data, config) {
  return post("/baseQuestionnaire/catalog/getById", data, config);
}
export function getCreateList(data, config) {
  return post("/baseQuestionnaire/catalog/getCreateList", data, config);
}
export function getList(data, config) {
  return post("/baseQuestionnaire/catalog/getList", data, config);
}
export function getPageInfo(data, config) {
  return post("/baseQuestionnaire/catalog/getPageInfo", data, config);
}
export function insertOrUpdate(data, config) {
  return post("/baseQuestionnaire/catalog/insertOrUpdate", data, config);
}
export function update(data, config) {
  return post("/baseQuestionnaire/catalog/update", data, config);
}